import { Avatar, Collapse, Divider, IconButton, InputAdornment, List, ListItem, ListItemIcon, ListItemText, TextField, ThemeProvider, Tooltip, Zoom, createTheme, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { AiOutlineMenu } from 'react-icons/ai';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { CiSearch } from 'react-icons/ci';
import { RiDashboardLine, RiNotification2Line } from 'react-icons/ri';
import { TbUser } from 'react-icons/tb';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserProfileContext } from '../../contexts/userProfile.jsx';
import DarkModeToggle from '../dark-reader/index.tsx';

import { DynamicIcon } from './dynamicIconLoader.tsx';
import './styles.css';

// imagens
import api from '../../services/api.js';
import { fetchMenuOptions } from '../../services/menuItems/fetchMenuItems.ts';

import { IoMdExit } from 'react-icons/io';
import { useAuth } from '../../contexts/authContext.tsx';
import { GrUpdate } from 'react-icons/gr';
import { normalizeStringFull } from '../../helpers/normalizer.ts';
import { Box } from '@mui/system';

export function NewMenuItens({
  open,
  setOpen,
  notificacoes,
  setNotificacoes,
  setSelected,
  setpatrimoniaisCloseAll,
  setPatrimoniaisAD,
  setpatrimoniaisExcel,
  setOpenFaturamento,
  setOpenNFS,
  setCadUsu,
  setPatrimoniaisFR,
  setIsOpenDRE,
  setIsOpenAdiocionarTopline,
  matches,
  setDatasFaltantesOp,
}) {
  const brand = process.env.REACT_APP_BRAND || 'Analytics';
  const logo = require(`../../assets/${brand}/appicon.png`);
  const logoBranca = require(`../../assets/${brand}/Logo_Mista.png`);

  const [cookies] = useCookies();
  const history = useNavigate();
  const { logout } = useAuth();
  const [controladoria, setControladoria] = useState({
    controladoria: false,
  });

  const [isDarkMode, setIsDarkMode] = useState(window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false);
  const [menuItems, setMenuItems] = useState([]);
  const { profileData } = React.useContext(UserProfileContext);

  useEffect(() => {
    const loadMenuItems = async () => {
      try {
        const permissao = cookies.usuario?.permissao;

        if (permissao === undefined || permissao === null) {
          console.error('Permissão não encontrada. Redirecionando para login...');
          return logout();
        }

        const data = await fetchMenuOptions(permissao);

        if (!data) {
          console.error('Falha ao carregar itens do menu. Redirecionando para login...');
          return logout();
        }

        setMenuItems(data.menuItems || []);
      } catch (error) {
        console.error('Erro ao carregar os itens do menu:', error);
        logout();
      }
    };

    loadMenuItems();
  }, [cookies, logout]);

  function openPage(url, params) {
    if (matches) setOpen(false);
    setControladoria({
      controladoria: false,
      usuario: false,
      revenue: false,
      faturamento: false,
    });
    setpatrimoniaisCloseAll();
    setSelected([]);
    if (params) {
      history(url, params);
    } else {
      history(url);
    }
  }

  const theme = createTheme();

  const useStyles = makeStyles(() => ({
    small: {
      width: theme.spacing(3) * 0.8,
      height: theme.spacing(3) * 0.8,
      marginRight: '-12px',
      marginLeft: '-12px',
      marginTop: '10px',
      marginBottom: '10px',
    },
    spinnerGrowSm: {
      // width: '0.5rem',
      // height: '0.5rem',
      width: '0.4rem',
      height: '0.4rem',
      position: 'absolute',
      top: '0px',
      // right: '10px',
      right: '8px',
    },
    spinnerGrowSmOpen: {
      float: 'right',
      // marginRight: ' 10px',
      marginRight: ' 8px',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1) * 0.8,
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    noPadding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }));

  const isMobile = useMediaQuery('(max-width: 680px)');
  const classes = useStyles();
  const location = useLocation();
  const currentPath = location.pathname;
  const isActive = (paths) => (paths.includes(location.pathname) ? 'menu-itens-dom' : '');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchUserTheme = async () => {
      try {
        const response = await api.get(`/usuarios/theme/${cookies.usuario.id}`, {
          headers: {
            authorization: `Bearer ${cookies.usuario.accessToken}`,
          },
        });
        const { darkmode } = response.data;
        setIsDarkMode(darkmode);
      } catch (err) {
        console.error('Erro ao buscar o tema do usuário:', err);
      }
    };

    if (cookies.usuario.id) {
      fetchUserTheme();
    }
  }, [cookies.usuario, isDarkMode]);

  const updateUserTheme = async (darkMode) => {
    try {
      await api.post(
        '/usuarios/theme',
        {
          id: cookies.usuario.id,
          darkmode: darkMode,
        },
        {
          headers: {
            authorization: `Bearer ${cookies.usuario.accessToken}`,
          },
        }
      );
      setIsDarkMode(darkMode);
    } catch (err) {
      console.error('Erro ao atualizar o tema do usuário:', err);
    }
  };

  const [expandedGroup, setExpandedGroup] = useState(null);
  const groupedMenuItems = {};
  const negativeOrderGroups = {};
  const ungroupedMenuItems = [];
  const negativeOrderItems = [];

  menuItems.forEach((item) => {
    if (item.url === '/home') {
      ungroupedMenuItems.push(item);
    } else if (item.grupo_conteudo_id) {
      const groupOrder = item.grupo_conteudo_ordem;
      if (groupOrder < 0) {
        if (!negativeOrderGroups[item.grupo_conteudo_id]) {
          negativeOrderGroups[item.grupo_conteudo_id] = {
            groupId: item.grupo_conteudo_id,
            groupName: item.grupo_conteudo_nome,
            groupIcon: item.grupo_conteudo_icon,
            groupAbbreviation: item.grupo_conteudo_abreviacao,
            grupoOrdem: groupOrder,
            items: [],
          };
        }
        negativeOrderGroups[item.grupo_conteudo_id].items.push(item);
      } else {
        if (!groupedMenuItems[item.grupo_conteudo_id]) {
          groupedMenuItems[item.grupo_conteudo_id] = {
            groupId: item.grupo_conteudo_id,
            groupName: item.grupo_conteudo_nome,
            groupIcon: item.grupo_conteudo_icon,
            groupAbbreviation: item.grupo_conteudo_abreviacao,
            grupoOrdem: groupOrder,
            items: [],
          };
        }
        groupedMenuItems[item.grupo_conteudo_id].items.push(item);
      }
    } else {
      if (item.ordem < 0) {
        negativeOrderItems.push(item);
      } else {
        ungroupedMenuItems.push(item);
      }
    }
  });

  const toggleGroup = (groupId) => {
    if (expandedGroup === groupId) {
      setExpandedGroup(null);
    } else {
      setExpandedGroup(groupId);
    }
  };

  ungroupedMenuItems.sort((a, b) => a.ordem - b.ordem);

  const orderedGroupedMenuItems = Object.values(groupedMenuItems).sort((a, b) => a.grupoOrdem - b.grupoOrdem);
  orderedGroupedMenuItems.forEach((group) => {
    group.items.sort((a, b) => a.ordem - b.ordem);
  });

  negativeOrderItems.sort((a, b) => a.ordem - b.ordem);

  const orderedNegativeOrderGroups = Object.values(negativeOrderGroups).sort((a, b) => a.grupoOrdem - b.grupoOrdem);
  orderedNegativeOrderGroups.forEach((group) => {
    group.items.sort((a, b) => a.ordem - b.ordem);
  });

  const urlActionMap = {
    '/patrimoniais/alugueisdividendos?modal=patrimonial_escolha': setPatrimoniaisAD,
    '/patrimoniais/orcadorealizado?modal=patrimonial_dre_oxr': setpatrimoniaisExcel,
    '?modal=fatpetro': setOpenFaturamento,
    '?modal=nfse1': setOpenNFS,
    '?modal=cad_usu': setCadUsu,
    '/patrimoniais/fundodereserva?modal_fundo_de_reserva': setPatrimoniaisFR,
    '?modal_verifica_pendencias': setDatasFaltantesOp,
    '?modal_cadatro_dre': setIsOpenDRE,
    '?modal_adicionar_dados': setIsOpenAdiocionarTopline,
  };

  function renderItem(item) {
    const isActive = item.url === currentPath;
    const isHome = item.url === '/home';

    let itemStyle = {
      paddingTop: 5,
      paddingBottom: 5,
      backgroundColor: isActive ? '#119e91' : 'inherit',
    };

    if (isHome) {
      itemStyle = {
        backgroundColor: isActive ? '#119e91' : '',
      };
    }

    const handleClick = () => {
      const action = urlActionMap[item.url];
      if (action) {
        action();
      } else {
        openPage(item.url, { state: { openModal: true } });
      }
    };

    return (
      <React.Fragment key={item.id}>
        {open ? (
          <ListItem onClick={handleClick} style={itemStyle}>
            <ListItemIcon>
              <DynamicIcon iconName={item.icon} fallbackName={item.paginaNome} />
            </ListItemIcon>
            <ListItemText>{item.paginaNome}</ListItemText>
          </ListItem>
        ) : (
          <Tooltip title={item.paginaNome} placement="right" TransitionComponent={Zoom}>
            <ListItem onClick={handleClick} style={itemStyle}>
              <ListItemIcon>
                <DynamicIcon iconName={item.icon} fallbackName={item.paginaNome} />
              </ListItemIcon>
            </ListItem>
          </Tooltip>
        )}
      </React.Fragment>
    );
  }

  function renderGroup(group) {
    const isGroupExpanded = expandedGroup === group.groupId;
    const hasActiveItem = group.items.some((item) => item.url === currentPath);

    const groupHeaderStyle = {
      paddingTop: 0,
      paddingBottom: 0,
      backgroundColor: !isGroupExpanded && hasActiveItem ? '#119e91' : '',
    };

    return (
      <React.Fragment key={group.groupId}>
        <Box
          key={group.groupId}
          sx={{
            boxShadow: isGroupExpanded ? 1 : 0,
            overflow: 'hidden',
          }}
        >
          {open ? (
            <ListItem onClick={() => toggleGroup(group.groupId)} style={groupHeaderStyle}>
              <ListItemIcon>
                <DynamicIcon iconName={group.groupIcon || 'RiFolderLine'} />
              </ListItemIcon>
              <ListItemText>{group.groupName}</ListItemText>
              {isGroupExpanded ? <BsChevronUp /> : <BsChevronDown />}
            </ListItem>
          ) : (
            <Tooltip title={group.groupName} placement="right" TransitionComponent={Zoom}>
              <ListItem onClick={() => toggleGroup(group.groupId)} style={groupHeaderStyle}>
                <ListItemIcon>
                  <DynamicIcon iconName={group.groupIcon || 'RiFolderLine'} />
                </ListItemIcon>
                <ListItemText>{group.groupAbbreviation}</ListItemText>
              </ListItem>
            </Tooltip>
          )}

          <Collapse in={isGroupExpanded || (!!searchQuery && group.items.some((item) => item.paginaNome.toLowerCase().includes(searchQuery.toLowerCase())))}>
            <Box
              sx={{
                backgroundColor: '#2fe6d328',
              }}
            >
              {group.items.map((item) => renderItem(item))}
            </Box>
          </Collapse>
          <Divider />
        </Box>
      </React.Fragment>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      {isMobile ? null : (
        <div
          className={classes.toolbar}
          style={{
            justifyContent: 'space-between',
            padding: '0 4px',
          }}
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <div>
              <img src={isDarkMode ? logoBranca : logo} alt={'Bup Icon'} className="analytics-header-logo" />
            </div>
          ) : null}
          <IconButton onClick={() => setOpen(!open)}>{open ? <BiDotsVerticalRounded /> : <AiOutlineMenu />}</IconButton>
        </div>
      )}
      <List style={{ paddingTop: 0, paddingBottom: 0 }} className={!controladoria.usuario ? isActive('/perfil') : ''}>
        <ListItem
          alignItems="center"
          style={{ paddingTop: 0, paddingBottom: 0 }}
          key={'Controladoria'}
          onClick={() =>
            setControladoria({
              ...controladoria,
              usuario: !controladoria.usuario,
            })
          }
        >
          <ListItemIcon>
            <Avatar className={classes.small} src={profileData?.foto_url || cookies.usuario.foto_url} />
            {controladoria.usuario || !notificacoes?.filter((d) => d.visualizado === false)?.length > 0 ? (
              ''
            ) : (
              <Spinner className={classes.spinnerGrowSm} size="sm" animation="grow" variant="danger" />
            )}
          </ListItemIcon>
          <ListItemText>{cookies?.usuario?.nome}</ListItemText>
        </ListItem>
        <Collapse in={controladoria.usuario}>
          {open ? (
            <ListItem
              style={{ paddingTop: 0, paddingBottom: 0 }}
              key={'Notificacoes'}
              onClick={() => {
                setOpen(false);
                setNotificacoes();
              }}
            >
              <ListItemIcon>
                {open &&
                  (notificacoes?.some((d) => !d.visualizado) ? (
                    <>
                      <RiNotification2Line style={{ float: 'right' }} />
                      <Spinner className={classes.spinnerGrowSm} size="sm" animation="grow" variant="danger" />
                    </>
                  ) : (
                    <RiNotification2Line style={{ float: 'right' }} />
                  ))}
              </ListItemIcon>
              <ListItemText>Notificações</ListItemText>
            </ListItem>
          ) : (
            <Tooltip title="Notificacoes" TransitionComponent={Zoom} placement="right">
              <ListItem
                style={{ paddingTop: 0, paddingBottom: 0 }}
                key={'Notificacoes'}
                onClick={() => {
                  setOpen(false);
                  setNotificacoes();
                }}
              >
                <ListItemIcon>
                  {notificacoes?.some((d) => !d.visualizado) ? (
                    <>
                      <RiNotification2Line style={{ float: 'right' }} />
                      <Spinner className={classes.spinnerGrowSm} size="sm" animation="grow" variant="danger" />
                    </>
                  ) : (
                    <RiNotification2Line style={{ float: 'right' }} />
                  )}
                </ListItemIcon>
                <ListItemText>Notificações</ListItemText>
              </ListItem>
            </Tooltip>
          )}
          <List style={{ paddingTop: 0, paddingBottom: 0 }} className={classes.noPadding && isActive('/perfil')}>
            {open ? (
              <ListItem
                style={{ paddingTop: 0, paddingBottom: 0 }}
                key={'Perfil de Usuário'}
                onClick={() => {
                  openPage('/perfil');
                }}
              >
                <ListItemIcon>
                  {' '}
                  <TbUser />{' '}
                </ListItemIcon>
                <ListItemText>Perfil de Usuário</ListItemText>
              </ListItem>
            ) : (
              <Tooltip title="Perfil de Usuário" TransitionComponent={Zoom} placement="right">
                <ListItem
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                  key={'Perfil de Usuário'}
                  onClick={() => {
                    openPage('/perfil');
                  }}
                >
                  <ListItemIcon>
                    <TbUser />
                  </ListItemIcon>
                  <ListItemText>Perfil de Usuário</ListItemText>
                </ListItem>
              </Tooltip>
            )}
          </List>
        </Collapse>
      </List>
      {open ? (
        <TextField
          size="small"
          variant="outlined"
          placeholder="Pesquisar..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onClick={() => setOpen(!open)}>
                  <CiSearch />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <Tooltip title="Pesquisar..." placement="right">
          <IconButton style={{ padding: '8px' }} size="small" onClick={() => setOpen(!open)}>
            <CiSearch />
          </IconButton>
        </Tooltip>
      )}

      <List style={{ paddingTop: 0 }}>
        {ungroupedMenuItems.map((item) => renderItem(item))}
        {orderedGroupedMenuItems.map((group) => renderGroup(group))}
      </List>

      <div style={{ height: '100%' }}></div>

      <List style={{ paddingTop: 0, paddingBottom: 0 }} className={classes.noPadding}>
        {!searchQuery || normalizeStringFull('Mudar cor do tema').includes(normalizeStringFull(searchQuery)) ? (
          open ? (
            <ListItem style={{ paddingTop: 0, paddingBottom: 0 }} key={'trocar-cor-do-tema'} onClick={() => updateUserTheme(!isDarkMode)}>
              <ListItemIcon>
                <DarkModeToggle isDarkMode={isDarkMode} setIsDarkMode={updateUserTheme} />
              </ListItemIcon>
              <ListItemText primary={'Mudar cor do tema'} />
            </ListItem>
          ) : (
            <Tooltip title="Mudar cor do tema" placement="right">
              <ListItem style={{ paddingTop: 0, paddingBottom: 0 }} key={'MudarCor'} onClick={() => updateUserTheme(!isDarkMode)}>
                <ListItemIcon>
                  <DarkModeToggle isDarkMode={isDarkMode} setIsDarkMode={updateUserTheme} />
                </ListItemIcon>
              </ListItem>
            </Tooltip>
          )
        ) : null}
      </List>
      <Divider />
      <List style={{ paddingTop: 0, paddingBottom: 0 }} className={classes.noPadding && isActive('/atualizacoes')}>
        {!searchQuery || normalizeStringFull('Atualizações do sistema').includes(normalizeStringFull(searchQuery)) ? (
          open ? (
            <ListItem
              style={{ paddingTop: 0, paddingBottom: 0 }}
              button
              key={'verAtualizacoes'}
              onClick={() => {
                openPage('/atualizacoes');
              }}
            >
              <ListItemIcon>
                <GrUpdate />
              </ListItemIcon>
              <ListItemText primary={'Atualizações do sistema'} />
              <Spinner className={classes.spinnerGrowSm} size="sm" animation="grow" variant="success" />
            </ListItem>
          ) : (
            <Tooltip title="Atualizações do sistema" TransitionComponent={Zoom} placement="right">
              <ListItem
                style={{ paddingTop: 0, paddingBottom: 0 }}
                button
                key={'verAtualizacoes'}
                onClick={() => {
                  openPage('/atualizacoes');
                }}
              >
                <ListItemIcon>
                  <GrUpdate />
                </ListItemIcon>
                <ListItemText primary={'Atualizações do sistema'} />
                <Spinner className={classes.spinnerGrowSm} size="sm" animation="grow" variant="success" />
              </ListItem>
            </Tooltip>
          )
        ) : null}
      </List>
      <Divider />
      <List>
        {negativeOrderItems.map((item) => renderItem(item))}
        {orderedNegativeOrderGroups.map((group) => renderGroup(group))}
      </List>

      <List style={{ paddingTop: 0, paddingBottom: 0 }} className={classes.noPadding}>
        {!searchQuery || normalizeStringFull('Sair').includes(normalizeStringFull(searchQuery)) ? (
          open ? (
            <ListItem style={{ paddingTop: 0, paddingBottom: 10 }} key={'Sair'} onClick={() => logout()}>
              <ListItemIcon>
                <IoMdExit />
              </ListItemIcon>
              <ListItemText primary={'Sair'} />
            </ListItem>
          ) : (
            <Tooltip title="Sair" placement="right">
              <ListItem style={{ paddingTop: 0, paddingBottom: 10 }} key={'Sair'} onClick={() => logout()}>
                <ListItemIcon>
                  <IoMdExit />
                </ListItemIcon>
              </ListItem>
            </Tooltip>
          )
        ) : null}
      </List>
    </ThemeProvider>
  );
}
